export enum OrganizationTypes {
  Supplier = "Supplier",
  Customer = "Customer",
}

export enum AccountingDateTypes {
  FinancialYear,
  PreviousFinancialYear,
  LastYear,
  Prior12Months,
  LastQuarter,
  CurrentMonth,
  Prior1Month,
  PreviousYearMonth,
  Prior3Months,
  Prior24Months,
}

export enum DocumentTypes {
  Receipt = 0,
  IncomingInvoice = 1,
  GenericDocument = 2,
  SIEFiles = 3,
  SelfInvoice = 4,
}

export enum SubComponentType {
  Dialog,
  TodoCard,
  Drawer,
}

export enum WintDeviationDateFilterTypes {
  CurrentMonth,
  PreviousMonth,
  CurrentVacationYear,
  AllHistory,
}